import { createFileRoute } from '@tanstack/react-router';
import { trpc } from '@/lib/trpc';
import { ProjectDetailView } from './-components/project-detail-view';
import { projectDetailSearchSchema } from './-components/project-detail-search';

export const Route = createFileRoute('/ngos/portals/$portalId_/projects/$projectId')({
	validateSearch: projectDetailSearchSchema,
	loader: ({ context, params }) => {
		context.queryClient.ensureQueryData(trpc.ngo.getProject.queryOptions({ projectId: params.projectId }));
		context.queryClient.ensureQueryData(trpc.ngo.getProjectCollected.queryOptions({ projectId: params.projectId }));
		context.queryClient.ensureQueryData(
			trpc.ngo.getProjectFundingHistory.queryOptions({ projectId: params.projectId }),
		);
		context.queryClient.ensureQueryData(trpc.ngo.getProfile.queryOptions());
		context.queryClient.ensureQueryData(trpc.ngo.getPortals.queryOptions());
		context.queryClient.ensureQueryData(trpc.ngo.getPortal.queryOptions({ portalId: params.portalId }));
	},
	component: ProjectDetailView,
});
